module.exports = __webpack_public_path__ + "static/media/uvi.ff8676e4.svg";